<script>
    import CloseButton from '@/components/Modals/CloseButton.vue';

    export default {
        components: { CloseButton },
        name: 'ConductInspectionModalNotes',
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        mounted() {
            this.$refs.notes.focus();
        },
        methods: {
            handleClose() {
                this.$emit('close');
            },

            handleSave() {
                this.$emit('save', this.$refs.notes.value.trim());
            },
        },
    };
</script>

<template>
    <modal @modal-close="handleClose">
        <div class="modal-wrapper">
            <CloseButton @click="handleClose" />

            <div class="modal-content">
                <textarea
                    ref="notes"
                    class="w-full form-input"
                    :placeholder="$t('Enter notes here')"
                    :value="item.notes"
                    rows="8"
                />
            </div>

            <div class="modal-actions-outer-wrapper">
                <div class="modal-actions-inner-wrapper">
                    <button
                        type="button"
                        class="modal-actions-secondary"
                        @click.prevent="handleClose"
                    >
                        {{ $t('Cancel') }}
                    </button>

                    <button
                        type="button"
                        class="modal-actions-primary"
                        @click.prevent="handleSave"
                    >
                        {{ $t('Save') }}
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>
